export default "__VITE_ASSET__V7xL3KzJ__"